module.exports = __webpack_public_path__ + "assets/img/noRanks.2ceb8bc2.png";